/* tslint:disable */
/* eslint-disable */
/**
 * Muscula App API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiErrorResponse,
  BaseAppInformationGenericApiResponse,
  FlatListOrder,
  GraphPopupEntryDtoListGenericApiResponse,
  GraphTimeSpan,
  LogOverviewDtoGenericApiResponse,
  LogOverviewDtoListGenericApiResponse,
  Severity,
} from '../models';
import {
    ApiErrorResponseFromJSON,
    ApiErrorResponseToJSON,
    BaseAppInformationGenericApiResponseFromJSON,
    BaseAppInformationGenericApiResponseToJSON,
    FlatListOrderFromJSON,
    FlatListOrderToJSON,
    GraphPopupEntryDtoListGenericApiResponseFromJSON,
    GraphPopupEntryDtoListGenericApiResponseToJSON,
    GraphTimeSpanFromJSON,
    GraphTimeSpanToJSON,
    LogOverviewDtoGenericApiResponseFromJSON,
    LogOverviewDtoGenericApiResponseToJSON,
    LogOverviewDtoListGenericApiResponseFromJSON,
    LogOverviewDtoListGenericApiResponseToJSON,
    SeverityFromJSON,
    SeverityToJSON,
} from '../models';

export interface ApiDashboardGraphPopupGetRequest {
    logsIds?: Array<string>;
    graphTimeSpan?: GraphTimeSpan;
    key?: string;
}

export interface ApiDashboardLogOverviewGetRequest {
    logId: string;
    page: number;
    limit?: number;
    orderBy?: FlatListOrder;
    graphTimeSpan?: GraphTimeSpan;
    starred?: boolean;
    showIgnored?: boolean;
    assignedTo?: string;
    searchFirstSeenFrom?: Date;
    searchFirstSeenTo?: Date;
    searchLastSeenFrom?: Date;
    searchLastSeenTo?: Date;
    searchSeverities?: Array<Severity>;
    searchSearchValue?: string;
    searchStructuralDataFilters?: Array<string>;
    apiKey?: string;
}

export interface ApiDashboardProjectDashboardGetRequest {
    projectId?: string;
    orderBy?: FlatListOrder;
    graphTimeSpan?: GraphTimeSpan;
}

/**
 * 
 */
export class DashboardApi extends runtime.BaseAPI {

    /**
     */
    async apiDashboardBaseAppInformationGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BaseAppInformationGenericApiResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Dashboard/BaseAppInformation`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BaseAppInformationGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiDashboardBaseAppInformationGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BaseAppInformationGenericApiResponse> {
        const response = await this.apiDashboardBaseAppInformationGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDashboardGraphPopupGetRaw(requestParameters: ApiDashboardGraphPopupGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GraphPopupEntryDtoListGenericApiResponse>> {
        const queryParameters: any = {};

        if (requestParameters.logsIds) {
            queryParameters['LogsIds'] = requestParameters.logsIds;
        }

        if (requestParameters.graphTimeSpan !== undefined) {
            queryParameters['GraphTimeSpan'] = requestParameters.graphTimeSpan;
        }

        if (requestParameters.key !== undefined) {
            queryParameters['Key'] = requestParameters.key;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Dashboard/graph-popup`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GraphPopupEntryDtoListGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiDashboardGraphPopupGet(requestParameters: ApiDashboardGraphPopupGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GraphPopupEntryDtoListGenericApiResponse> {
        const response = await this.apiDashboardGraphPopupGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDashboardLogOverviewGetRaw(requestParameters: ApiDashboardLogOverviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogOverviewDtoGenericApiResponse>> {
        if (requestParameters.logId === null || requestParameters.logId === undefined) {
            throw new runtime.RequiredError('logId','Required parameter requestParameters.logId was null or undefined when calling apiDashboardLogOverviewGet.');
        }

        if (requestParameters.page === null || requestParameters.page === undefined) {
            throw new runtime.RequiredError('page','Required parameter requestParameters.page was null or undefined when calling apiDashboardLogOverviewGet.');
        }

        const queryParameters: any = {};

        if (requestParameters.logId !== undefined) {
            queryParameters['LogId'] = requestParameters.logId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['Page'] = requestParameters.page;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['Limit'] = requestParameters.limit;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['OrderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.graphTimeSpan !== undefined) {
            queryParameters['GraphTimeSpan'] = requestParameters.graphTimeSpan;
        }

        if (requestParameters.starred !== undefined) {
            queryParameters['Starred'] = requestParameters.starred;
        }

        if (requestParameters.showIgnored !== undefined) {
            queryParameters['ShowIgnored'] = requestParameters.showIgnored;
        }

        if (requestParameters.assignedTo !== undefined) {
            queryParameters['AssignedTo'] = requestParameters.assignedTo;
        }

        if (requestParameters.searchFirstSeenFrom !== undefined) {
            queryParameters['Search.FirstSeenFrom'] = (requestParameters.searchFirstSeenFrom as any).toISOString();
        }

        if (requestParameters.searchFirstSeenTo !== undefined) {
            queryParameters['Search.FirstSeenTo'] = (requestParameters.searchFirstSeenTo as any).toISOString();
        }

        if (requestParameters.searchLastSeenFrom !== undefined) {
            queryParameters['Search.LastSeenFrom'] = (requestParameters.searchLastSeenFrom as any).toISOString();
        }

        if (requestParameters.searchLastSeenTo !== undefined) {
            queryParameters['Search.LastSeenTo'] = (requestParameters.searchLastSeenTo as any).toISOString();
        }

        if (requestParameters.searchSeverities) {
            queryParameters['Search.Severities'] = requestParameters.searchSeverities;
        }

        if (requestParameters.searchSearchValue !== undefined) {
            queryParameters['Search.SearchValue'] = requestParameters.searchSearchValue;
        }

        if (requestParameters.searchStructuralDataFilters) {
            queryParameters['Search.StructuralDataFilters'] = requestParameters.searchStructuralDataFilters;
        }

        if (requestParameters.apiKey !== undefined) {
            queryParameters['ApiKey'] = requestParameters.apiKey;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Dashboard/log-overview`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogOverviewDtoGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiDashboardLogOverviewGet(requestParameters: ApiDashboardLogOverviewGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogOverviewDtoGenericApiResponse> {
        const response = await this.apiDashboardLogOverviewGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiDashboardProjectDashboardGetRaw(requestParameters: ApiDashboardProjectDashboardGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LogOverviewDtoListGenericApiResponse>> {
        const queryParameters: any = {};

        if (requestParameters.projectId !== undefined) {
            queryParameters['ProjectId'] = requestParameters.projectId;
        }

        if (requestParameters.orderBy !== undefined) {
            queryParameters['OrderBy'] = requestParameters.orderBy;
        }

        if (requestParameters.graphTimeSpan !== undefined) {
            queryParameters['GraphTimeSpan'] = requestParameters.graphTimeSpan;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/Dashboard/project-dashboard`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LogOverviewDtoListGenericApiResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiDashboardProjectDashboardGet(requestParameters: ApiDashboardProjectDashboardGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LogOverviewDtoListGenericApiResponse> {
        const response = await this.apiDashboardProjectDashboardGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
